import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-xl text-accent-500 whitespace-nowrap">
              喵趣漫画
            </Link>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
              喵趣漫画网为您汇集韩漫、日漫与国漫免费全集，支持下拉式在线阅读，让您一口气看完热门漫画大全。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-categories" className="hover:text-accent-400 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-quick-links" className="hover:text-accent-400 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap">
                  全部漫画
                </Link>
              </li>
              <li>
                <Link to="/category/korean" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap">
                  韩漫专区
                </Link>
              </li>
              <li>
                <Link to="/category/japanese" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap">
                  日漫专区
                </Link>
              </li>
              <li>
                <Link to="/category/chinese" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap">
                  国漫专区
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-contact" className="hover:text-accent-400 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2 text-sm text-foreground-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-500"></i>
                <span>contact@miaoqucomic.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-accent-500"></i>
                <span>在线客服：7×24小时</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-500"></i>
                <span>中国·北京</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} 喵趣漫画网 miaoqucomic.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <a href="#privacy" className="hover:text-accent-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#terms" className="hover:text-accent-400 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#dmca" className="hover:text-accent-400 transition-colors whitespace-nowrap">DMCA</a>
          </div>
        </div>
      </div>
    </footer>
  );
}